<div class="modal-header">
    <h4 class="modal-title pull-left"> {{ isEdit ? 'Edit Client': 'New Client' }} </h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">
    <page-client-edit
        [edit]="isEdit" [client]="client" [compact]="compact"
        (onCreate)="onConfirm($event)"
        (onCancel)="onCancel()">
    </page-client-edit>
</div>
